import { dashboardsSelector } from "./dashboardsSelector";
import { RootState } from "../../../store";

export const dashboardsCountSelector = (state: RootState) => {
  return dashboardsSelector(state)?.length;
};
